import { MIN_DATE_RANGE } from '@/config/constants';
import { parseRelativeDateSelection } from '@/shared/lib/date/parseRelativeDateSelection';

export function parseFromToISO(from: string | undefined) {
  if (from) {
    if (from === 'mtd' || from === 'ytd') {
      const fromDate = parseRelativeDateSelection(1, from);
      return fromDate.toISOString();
    }

    const relativeMatch = /^(\d+)(d|m|y|mtd|ytd)$/.exec(from);
    if (relativeMatch) {
      const [, compareTo, compareToUnit] = relativeMatch;
      const fromDate = parseRelativeDateSelection(Number(compareTo), compareToUnit);
      return fromDate.toISOString();
    }

    const absoluteDate = new Date(from);
    if (!Number.isNaN(absoluteDate.getTime())) {
      return absoluteDate.toISOString();
    }

    return MIN_DATE_RANGE;
  }
  return MIN_DATE_RANGE;
}
